import { ref, watch } from 'vue'
import { setAppLocale, type AppLocale } from '@/i18n'

function readQueryLocale(): AppLocale {
  const q = new URLSearchParams(window.location.search).get('lang')
  return q === 'en' ? 'en' : 'de'
}

const locale = ref<AppLocale>(readQueryLocale())
setAppLocale(locale.value)
watch(locale, (l) => setAppLocale(l))

export function useLocale() {
  return locale
}
